import { render } from "./StudentProfilePage.vue?vue&type=template&id=b593e302&scoped=true"
import script from "./StudentProfilePage.vue?vue&type=script&lang=js"
export * from "./StudentProfilePage.vue?vue&type=script&lang=js"

import "./StudentProfilePage.vue?vue&type=style&index=0&id=b593e302&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b593e302"]])

export default __exports__